import Swal from "sweetalert2";

export function SweetAlertDangerModal(text) {
  return Swal.fire({
    text,
    icon: "error",
    showConfirmButton: "Ok",
  });
}
